// Axis, grid and crosshair treatment for the analytics line/bar charts. Mirrors the
// CRM chart theme in ListingViewsCard so BoomScreen and BoomCRM charts read the same:
// a hairline axis domain line, 12px grey tick labels and dashed horizontal gridlines.
export const CHART_THEME = {
  axis: {
    domain: { line: { stroke: "#F1F3F9", strokeWidth: 1 } },
    ticks: {
      line: { stroke: "transparent", strokeWidth: 0 },
      text: { fontSize: 12, fill: "#8B8D97" }
    }
  },
  grid: {
    line: { stroke: "#F1F3F9", strokeWidth: 1, strokeDasharray: "4 4" }
  },
  // The hovered column is marked with a dotted guide, per the design. Shared by every
  // line chart that opens a slice tooltip so the guide reads the same on all of them.
  crosshair: {
    line: {
      stroke: "#0F172A",
      strokeWidth: 1,
      strokeOpacity: 0.2,
      strokeDasharray: "2 4"
    }
  }
};
